import BaseService from './base'

export default class AccountService extends BaseService {
  static resource() {
    return 'api/v1/external/accounts'
  }
}
